export { default as GDMGrid } from './GDMGrid';

export type { GDMGridComponent, GDMGridProps } from './GDMGrid.type';
